<template>
  <div>
    <div class="topbar">
      <div class="clearfix main-wrap">
        <a class="pull-left img-back" href="javascript:window.history.go(-1)">返回</a>
        <h1>{{bannerInfo.imgRemark}}</h1>
      </div>
      <div class="liner"></div>
    </div>

    <div class="main-page bg-white">
      <div id="myIframe"></div>
    </div>
  </div>
</template>

<script>
import { service } from '../../service'
export default {
  data () {
    return {
      windowHeight: 0,
      adId: 0,
      get_banner_para: service.setPara('getBanner'),
      bannerInfo: {}
    }
  },
  mounted: function () {
    if (this.adId != this.$route.params.adId) {
      this.adId = this.$route.params.adId
      $('#myIframe iframe').remove()
      this.getBanner()
    }
  },
  methods: {
    getBanner: function () {
      this.get_banner_para.adId = this.adId

      let that = this
      let obj = {context: this, para: this.get_banner_para, successFun: (response) => {
        that.bannerList = response.data
        if (that.bannerList.length > 0) {
          that.bannerInfo = that.bannerList[0]
          Vue.nextTick(function () {
            $('#myIframe').html('<iframe id="myIframe" width="100%" frameborder="0" height="' + $(window).height() + '" src="' + that.bannerInfo.outUrl + '"></iframe>')
          })
        }
      }}
      service.request(obj)
    }
  }
}
</script>


// WEBPACK FOOTER //
// AdInfo.vue?2d365e88